module.exports = __webpack_public_path__ + "img/图片6.fb6f0429.png";